import * as Yup from "yup";

const TRFOrderValidation = Yup.object().shape({
 firstName: Yup.string().required("First Name is required!"),
 lastName: Yup.string().required("Last Name is required!"),
 paperTRFDocuments: Yup.array()
  .required("Paper TRF Documents is required!")
  .min(1, "Paper TRF Documents is required!"),
});

export default TRFOrderValidation;
